import React from 'react';
import './RotateOverlay.css';

/** Mobile only: block landscape and ask for portrait. Desktop never shows this. */
export default function RotateOverlay() {
  return (
    <div className="sop-rotate-overlay" id="popup" role="dialog" aria-live="polite">
      <p>Kindly rotate your phone to portrait mode</p>
    </div>
  );
}
